import { render, staticRenderFns } from "./chronology-comment.vue?vue&type=template&id=22a34aae&"
import script from "./chronology-comment.vue?vue&type=script&lang=ts&"
export * from "./chronology-comment.vue?vue&type=script&lang=ts&"
import style0 from "./chronology-comment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports